import {createAction} from 'redux-actions';
import {TREE_FETCH} from '../action-types';

export const fetchTree = createAction(TREE_FETCH, tag => v12.category.tree(tag, {key: 'tag', query: v12.options.defaults}));
